/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useRef } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { DisputeCodesSelected, ManufactureTableHead } from './TableHead';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  tabHighLigther,
  autoFormateDate,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  quarterTest1,
  quarterTest2,
  lowerCaseAllWordsExceptFirstLetters,
  upperCaseFirstLetter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import {
  dispatchErrorMsgRosi,
  dispatchPerformRosiResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  getManufactureName,
  getManufactureID,
  getSelectedOption,
  dispatchDrugData,
  getManufacturerList,
  dispatchFromRosi,
  dispatchErrorMsgNDCDetail,
  dispatchSearchType,
  dispatchIndex,
  getRosiGrid,
  dispatchRosiGrid,
  dispatchDisplayObjRosi,
  getLabelerList,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  SELECT_MANUFACTURER,
  NDC_LIMIT_TO_1000,
} from '../../../../SharedModules/Errors/constantMessageData';
import { navigateToRequest, viewClaimDetailButton } from './ConstantData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const Rosi = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const requestCurrentDisData = useSelector(
    (state) => state?.sharedState?.RosiReducer?.performRosiResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.RosiReducer?.planType
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.RosiReducer?.rebateProgram
  );
  const resultManufacturerGrid = useSelector(
    (state) => state?.sharedState?.RosiReducer?.manufacturerList
  );
  const getRosiList = useSelector(
    (state) => state?.sharedState?.RosiReducer?.gridROSI
  );
  const {
    rebateProgramName: getRebateProgramName,
    selectedValue: selectedValueOption,
    quarterFrom: getQuarter,
    selectedSearchType,
    selectedPlanType,
    ndcLeftTableData: ndcLeftTableDataArr,
    labelerSelectedRow: labelerSelectedRowValue,
    selectedNDC,
    selectRowIndex: selectRowIndexValue,
  } = useSelector((state) => state?.sharedState?.RosiReducer);
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.RosiReducer?.errorMsgRosi
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  // get error msg for NDC
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = getErrorMsg?.searchScreenErrors
        ? getErrorMsg?.searchScreenErrors
        : [];
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        dispatchErrorMsgNDCDetail({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd:
            getRebateProgramName?.rebateProgramCd ||
            userDefaults?.rebateProgramCd
              ? getRebateProgramName?.rebateProgramCd ||
                userDefaults?.rebateProgramCd
              : '-1',
          Open: true,
          Closed: false,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );
  const searchCompObj = requestCurrentDisData?.state?.searchTypeState;
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    labelerSelectedRowValue
  );

  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = React.useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = React.useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] =
    React.useState(ndcLeftTableDataArr);
  const [ndcRightTableData, setNdcRightTableData] = React.useState(selectedNDC);
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [selectesNdc, setSelectedNdc] = React.useState([]);
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );

  const errorMessagesOfSearchTypeComp =
    getErrorMsg?.searchScreenErrors?.length > 0
      ? _.filter(
          getErrorMsg?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [radioList, setRadioList] = React.useState([]);
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [searchType, setSearchType] = React.useState(selectedSearchType);
  const gridRef = React.useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);

  const dispatch = useDispatch();
  const [selectedValue, setselectedValue] = React.useState(selectedValueOption);
  const [checked, setChecked] = React.useState(false);

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [menuName, setMenuName] = React.useState([]);
  const [manufacturerWithId, setManufactureWithId] = React.useState([]);

  const [quarter, setQuarter] = React.useState(getQuarter);
  useEffect(() => {
    setQuarter(getQuarter);
  }, [getQuarter]);
  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  // dispatch function
  const setPerformDisputeScrData = (value) =>
    dispatch(dispatchPerformRosiResolutionObj(value));

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);
  // Function to get the labeler code data in case of NDC and name selected
  const getLabelerData = async () => {
    const labelerTableData = await getLabelerList({
      searchType: 'labeler',
    });
    setlabelerTableData(labelerTableData);
  };

  //reseting error message on input fields change
  React.useEffect(() => {
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: [] }));
  }, [state.planTypeCd, state.rebateProgramCd, quarter, selectedValue, searchType, ndcSearchVal, ndcNameSearchVal, ndcRightTableData, manufacturerWithId,
    labelerSelectedRow, ndcLeftSelectedRows, ndcRightSelectedRows ])

  const settinglabelerSelectedRow = (data) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    localErr = localErr.filter((item) => item.field !='noData');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: unique }));
    setlabelerSelectedRow(data);
  }

  React.useEffect(() => {
    if (selectedValueOption !== 'Labeler') {
      getLabelerData();
    }
  }, []);
  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    if (name === 'selectBy' && value !== state.selectBy) {
      setState({
        ...state,
        [name]: value,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });
      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'NDC'
      );
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');
      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      setPerformDisputeScrData({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          [name]: value,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      localErr = localErr.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      setErrorMsgFromSearchType([]);
    }
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformDisputeScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformDisputeScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd' && item.field != "noData");
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: unique }));
  };
  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }
    if (type === 'quarter') {
      value = autoFormateDate(data);
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'quarterRequired',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'startQtr',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          setQuarter(value?.toUpperCase());
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        if (type === 'quarter') {
          localErr.push({
            field: 'quarter',
            errorType: 'quarterRequired',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: unique }));
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Grid functionality for mfg

  const [numberOfSelectedRows, setNumberOfSelectedRows] = React.useState(0);
  const onSelectionChanged = (e) => {
    const selectedRows = e?.api?.getSelectedRows();
    setNumberOfSelectedRows(e?.api?.getSelectedRows().length);

    const temp = [];
    const selectedMenuName = [];
    for (let i = 0; i < selectedRows?.length; i++) {
      selectedMenuName.push(selectedRows[i].mfgName);
      temp.push({
        manufacturerID: selectedRows[i].mfgId,
        manufacturerName: selectedRows[i].mfgName,
      });
    }
    selectedMenuName.sort();
    setMenuName(selectedMenuName);

    setManufactureWithId(temp);

    setSelectedRows(selectedRows);
    let localErr = getErrorMsg?.searchScreenErrors || [];
    localErr = localErr.filter((item) => item.field != 'nomanufacture' && item.field !='noData');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: unique }));
  };
  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO);
  }, [resultManufacturerGrid]);
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);
  // Search button on click functionality
  const onClickOnSearch = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = []
  ) => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );

    // let index = manufacturerList.findIndex(
    //   (obj) =>
    //     obj.mfgId === selectedRows[0]?.mfgId ||
    //     obj.mfgId === selectedRowOnDoubleClick[0]?.mfgId
    // );
    // index = index === -1 ? null : index;

    const index = null;

    let MfgWithId = manufacturerWithId;
    let mfgwithName = menuName;
    let sRows = selectedValue ? selectedRows : [];

    if (onDoubleClick) {
      MfgWithId = [
        {
          manufacturerID: selectedRowOnDoubleClick[0].mfgId,
          manufacturerName: selectedRowOnDoubleClick[0].mfgName,
        },
      ];
      mfgwithName = [selectedRowOnDoubleClick[0].mfgName];
      sRows = selectedRowOnDoubleClick;
    }
    let localErr = getErrorMsg?.searchScreenErrors || [];
    if (sRows.length === 0) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'nomanufacture');
      localErr.push({
        field: 'nomanufacture',
        errorType: 'manufactureRequired',
        message: SELECT_MANUFACTURER,
      });
    }

    if (!quarter) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'quarterRequired',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: unique }));
    if (unique.length) return;
    // AutoScroll to show validation msg
    if (
      state?.rebateProgramCd === '-1' ||
      quarter === '' ||
      MfgWithId.length === 0
    ) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      return;
    }

    if (
      state?.rebateProgramCd != '-1' &&
      quarter != '' &&
      MfgWithId.length != 0
    ) {
      function convertDate(mQyyyy) {
        // Extract quarter, month, and year from the input string
        const quarter = parseInt(mQyyyy.charAt(0));
        const year = parseInt(mQyyyy.slice(-4));

        // Calculate the month based on the quarter
        const month = (quarter - 1) * 3 + 1;

        // Convert month and year to two-digit format if needed
        const monthFormatted = month.toString().padStart(2, '0');
        const yearFormatted = year.toString();

        // Combine the formatted values to form the final date string
        const dateFormatted = `${monthFormatted}/01/${yearFormatted}`;

        return dateFormatted;
      }
      const convertedDate = convertDate(quarter);
      const type = resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO?.map(
        (obj) => obj.mfgTypeCd
      );
      const mID = MfgWithId?.map((obj) => obj.manufacturerID);

      dispatch(dispatchRosiGrid([]));
      setSearchClicked(true);
      dispatch(
        getRosiGrid({
          mfgTypeCd: type[0],
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          mfgId: mID.toString(),
          drugSeqNum: ['0'],
          qtr: quarter,
          startDate: convertedDate,
          familySeqNum: 1,
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));

      dispatch(getManufactureName(mfgwithName));
      dispatch(getManufactureID(MfgWithId));
      dispatch(dispatchIndex({ selectRowIndex: index }));
      dispatch(dispatchSearchType({ selectedSearchType: searchType }));
      dispatch(getSelectedOption(selectedValue));
      dispatch(dispatchFromRosi(quarter));
      dispatch(
        dispatchDisplayObjRosi({
          rebateProgramName,
          selectedValue,
          allManufacturer: mfgwithName,
          manufactureWithIds: MfgWithId,
          selectRowIndex: index,
          selectedSearchType: searchType,
          quarterFrom: quarter,
          labelerTableData,
        })
      );
    }
  };

  // AutoScroll to show validation msg
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.searchScreenErrors?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);

  if (isSearchClicked && getRosiList?.rosiPqasRosiGridVO?.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayrosi_pqas',
      value: 'ROSI/PQAS Detail Report',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayrosi_pqas',
    });
    dispatch(clearReduxForFilterAndSort('/displayrosi_pqas'));
  }
  // ndc search
  const onSearch = (data) => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg?.searchScreenErrors || [];
    if (!quarter) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'quarterRequired',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: unique }));

    // AutoScroll to show validation msg
    if (state?.rebateProgramCd === '-1' || quarter === '') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      return;
    }
    if (state.rebateProgramCd != '-1' && quarter != '') {
      function convertDate(mQyyyy) {
        // Extract quarter, month, and year from the input string
        const quarter = parseInt(mQyyyy.charAt(0));
        const year = parseInt(mQyyyy.slice(-4));

        // Calculate the month based on the quarter
        const month = (quarter - 1) * 3 + 1;

        // Convert month and year to two-digit format if needed
        const monthFormatted = month.toString().padStart(2, '0');
        const yearFormatted = year.toString();

        // Combine the formatted values to form the final date string
        const dateFormatted = `${monthFormatted}/01/${yearFormatted}`;

        return dateFormatted;
      }
      const convertedDate = convertDate(quarter);
      const type = resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO?.map(
        (obj) => obj.mfgTypeCd
      );

      const mID = data?.map((obj) => obj.labelerCode);
      dispatch(dispatchRosiGrid([]));
      setSearchClicked(true);
      dispatch(dispatchFromRosi(quarter));
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(getManufactureName(menuName));
      dispatch(getManufactureID(manufacturerWithId));
      dispatch(getSelectedOption(selectedValue));
      dispatch(
        dispatchDrugData({
          selectedNDC: data,
          ndcLeftTableData,
          labelerSelectedRow,
        })
      );
      dispatch(
        dispatchDisplayObjRosi({
          rebateProgramName,
          selectedValue,
          allManufacturer: menuName,
          manufactureWithIds: manufacturerWithId,
          selectedNDC: data,
          ndcLeftTableData,
          labelerSelectedRow,
          quarterFrom: quarter,
          labelerTableData,
        })
      );
      dispatch(dispatchSearchType({ selectedSearchType: searchType }));
      if (data.length == 1) {
        dispatch(
          getRosiGrid({
            mfgTypeCd: type[0],
            rebateProgramCd: rebateProgramName?.rebateProgramCd,
            mfgId: mID.toString(),
            drugSeqNum: data.map((obj) => obj.drugSeqNum),
            qtr: quarter,
            startDate: convertedDate,
            familySeqNum: 1,
          })
        );
      } else if (data.length > 1000) {
        setConfirmAction(true);
        setSelectedNdc(data.filter((o, ind) => ind < 1000));
      } else {
        const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) === null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.push({
            navTo: '/displayrosi_pqas',
            value: 'ROSI/PQAS Detail Report',
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          props.history.push({
            pathname: '/displayrosi_pqas',
          });
          dispatch(clearReduxForFilterAndSort('/displayrosi_pqas'));
      }
    }
  };
  if (isSearchClicked && getRosiList?.rosiPqasRosiGridVO?.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayrosi_pqas',
      value: 'ROSI/PQAS Detail Report',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayrosi_pqas',
    });
    dispatch(clearReduxForFilterAndSort('/displayrosi_pqas'));
  }
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformDisputeScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };

  const handlefromChange = (event) => {
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setQuarter(value);
    let localErr = getErrorMsg?.searchScreenErrors || [];
    localErr = localErr.filter((item) => item.field !== 'quarter');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRosi({ searchScreenErrors: unique }));
  };

  const cellClickedListener = (e) => {
    setManufactureWithId([e?.data]);
    onClickOnSearch(null, true, [e?.data]);
  };

  const errorMessages = [
    ...new Set(getErrorMsg?.searchScreenErrors?.map((obj) => obj.message)),
  ];
  const [gridApi, setGridApi] = React.useState(null);
    const onGridReady = (params) => {
      setGridApi(params.api);
    };
    React.useEffect(() => {
      if (!gridApi || manufacturerList === 0) return;
      const selectedRows = gridApi.getSelectedRows();
      if (selectedRows.length > 0) return;
      const firstNode = gridApi.getDisplayedRowAtIndex(0);
      if (firstNode) {
        firstNode.setSelected(true);
        onSelectionChanged({ api: gridApi }); 
      }
    }, [gridApi, manufacturerList]);
  return (
    <div
      className=" tabs-container tBillPanel custom-check"
      data-testid="Rosi-PQAS-report"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Detail Reports" parent2="ROSI/PQAS Report" />

      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />

      {!fullScreenView && (
        <>
          <div className="tab-body">
            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="radio-button-for-rcdd"
                  id="radio-button-for-rcdd_id"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={state && state.planTypeCd}
                  filterAction={(e) => {
                    handleOnChangeEvent(e, 'planTypeCd');
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Rebate Program <span className="mandatory"> *</span>{' '}
                  </legend>
                  <div className="form-wrapper p-3">
                    <div className="mui-custom-form field-xl no-lbl">
                      <TextField
                        data-testid="rebate_program-ia"
                        id="rebate_program"
                        label="rebate_program"
                        fullWidth
                        select
                        required
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'rebate_program' }}
                        onBlur={(e) =>
                          handleOnblurEvent('rebateProgramCd', e.target.value)
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={state && state.rebateProgramCd}
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                        }
                        className={
                          getErrorMsg?.searchScreenErrors?.length > 0
                            ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                                l.field === 'rebateProgramCd'
                                  ? 'mandate-fields'
                                  : null
                              )
                            : null
                        }
                        helperText={
                          getErrorMsg?.searchScreenErrors?.length > 0
                            ? [
                                ...new Set(
                                  getErrorMsg?.searchScreenErrors
                                    ?.filter((x) => {
                                      return x.field === 'rebateProgramCd';
                                    })
                                    .map((item) => {
                                      return item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          getErrorMsg?.searchScreenErrors?.length > 0 &&
                          getErrorMsg?.searchScreenErrors?.filter((x) => {
                            return x.field === 'rebateProgramCd';
                          }).length > 0
                            ? [
                                ...new Set(
                                  getErrorMsg?.searchScreenErrors
                                    ?.filter((x) => {
                                      return x.field === 'rebateProgramCd';
                                    })
                                    .map((item) => {
                                      return item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {rebateProgramList?.length > 0
                          ? rebateProgramList.map((item) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Quarter <span className="mandatory"> *</span>{' '}
                  </legend>
                  <div className="form-wrapper p-3">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        id="check_by_invoice_quater"
                        data-testid="check_by_rosi_pqas_quater"
                        label="rosipqs"
                        required
                        fullWidth
                        value={quarter}
                        onChange={handlefromChange}
                        placeholder=""
                        inputProps={{
                          maxLength: 6,
                          id: 'check_by_invoice_quater',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={
                          getErrorMsg?.searchScreenErrors?.length > 0
                            ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                                l.field == 'quarter' ? 'mandate-fields' : null
                              )
                            : null
                        }
                        onBlur={(e) =>
                          handleOnblurEvent('quarter', e.target.value)
                        }
                        helperText={
                          getErrorMsg?.searchScreenErrors?.length > 0
                            ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                                l.field === 'quarter' ? l.message : null
                              )
                            : null
                        }
                        error={
                          getErrorMsg?.searchScreenErrors?.length > 0
                            ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                                l.field == 'quarter' ? l.message : null
                              )
                            : null
                        }
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-4 ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Select one Option <span className="mandatory"> *</span>{' '}
                </legend>

                <div className="sub-radio no-margin">
                  <FormControl>
                    <RadioGroup
                      row
                      name="Select one Option"
                      required
                      value={selectedValue}
                    >
                      <FormControlLabel
                        style={{ marginRight: '10px' }}
                        value="Manufacturer"
                        control={<Radio />}
                        data-testid="Manufacturer-rosi-qpas"
                        label="Select a Manufacturer"
                        onChange={(e) => setselectedValue(e.target.value)}
                      />
                      <FormControlLabel
                        style={{ marginRight: '10px' }}
                        value="NDC"
                        control={<Radio />}
                        label="NDC"
                        data-testid="NDC-rosi-qpas"
                        onChange={(e) => setselectedValue(e.target.value)}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </fieldset>
            </div>
          </div>
        </>
      )}
      <div className="row">
        {selectedValue == 'NDC' && (
          <div className="col-sm-12">
            <SearchTypeComponent
              id="claimAuditSelect"
              data-testid="NDC_Grid"
              viewDetailButtonName={viewClaimDetailButton}
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={onSearch}
              setlabelerSelectedRow={settinglabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
              iconName="search"
            />
          </div>
        )}
      </div>
      <div className="col-12 btn-wrapper mb-2">
        <div className="float-right mt-2 hide-on-print">
          {selectedValue == 'Manufacturer' && (
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={onClickOnSearch}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          )}
        </div>
      </div>
      <br />
      <br />
      {selectedValue == 'Manufacturer' && (
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGrid
            onSelectionChanged={onSelectionChanged}
            gridCall={onGridReady}
            ref={gridRef}
            data-testid="manufacturer-grid"
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            columnDefs={ManufactureTableHead}
            rowData={manufacturerList}
            rowSelection="single"
            cellClickedListener={cellClickedListener}
            selectRowIndex={selectRowIndexValue}
            rowMultiSelectWithClick
            exportFile
            animateRows
            sideBar={false}
            fileName="Manufacturer Grid"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            // isScrollOn={true}
            // defaultColWidth={180}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name && `${name}`}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      )}
      <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          setConfirmAction(false);
          dispatch(
            dispatchDrugData({
              selectedNDC: selectesNdc,
              ndcLeftTableData,
              labelerSelectedRow,
            })
          );
          const rebateProgramName = rebateProgramList.find(
            (item) => item.id == state.rebateProgramCd
          );
          dispatch(
            dispatchDisplayObjRosi({
              rebateProgramName,
              selectedValue,
              allManufacturer: menuName,
              manufactureWithIds: manufacturerWithId,
              selectedNDC: selectesNdc,
              ndcLeftTableData,
              labelerSelectedRow,
              quarterFrom: quarter,
              labelerTableData,
            })
          );
          const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) === null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.push({
            navTo: '/displayrosi_pqas',
            value: 'ROSI/PQAS Detail Report',
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          props.history.push({
            pathname: '/displayrosi_pqas',
          });
          dispatch(clearReduxForFilterAndSort('/displayrosi_pqas'));
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Confirmation Dialog"
        childrenComponent={NDC_LIMIT_TO_1000}
      />
    </div>
  );
};

export default Rosi;
